import { formatNumber } from '@utils/format-number/format-number';

export const getCurrencySymbol = (currency: string) => {
  const formattedPrice = formatNumber({
    locale: 'en-US',
    currency,
    number: 0,
  });
  if (!formattedPrice) throw new Error(`Invalid currency: ${currency}`);
  return formattedPrice.replace(/[\d.,\s]/g, '');
};
